<skl-dialog-content-ins>
	<skl-dialog-header-ins
		id="clients-filter-dialog-header"
		[title]="'scenes.shared.dialog.client-filter-dialog.title' | translate"
		(onClose)="onCancel()">
	</skl-dialog-header-ins>

	<ins-content>
		<skl-form-container>
			<ins-form-field
				[skl-focus-by]
				[label]="'scenes.shared.dialog.client-filter-dialog.form.value.label' | translate">
				<skl-quick-list-ins
					[locked]="true"
					id="clients-filter-dialog-value"
					[(ngModel)]="viewModel.client.value"
					[displayText]="'name'"
					[placeholder]="'scenes.shared.dialog.client-filter-dialog.form.value.placeholder' | translate">
					<ins-option
						class="option option--multiline"
						*sklDynamicList="let item of viewModel.clientFilter"
						[value]="item">
						<skl-client-quick-list-item
							[data]="item"
							(onSwitch)="viewModel.onClientFavouriteSwitch()">
						</skl-client-quick-list-item>
					</ins-option>
				</skl-quick-list-ins>
			</ins-form-field>
		</skl-form-container>
	</ins-content>

	<ins-footer class="dialog__buttons">
		<skl-button
			id="clients-filter-dialog-cancel-button"
			(click)="onCancel()">
			{{'scenes.shared.dialog.client-filter-dialog.buttons.cancel' | translate}}
		</skl-button>
		<skl-button
			typeName="accent"
			id="clients-filter-dialog-confirm-button"
			[disabled]="!viewModel.client.value"
			(click)="chooseItem()">
			{{'scenes.shared.dialog.client-filter-dialog.buttons.save' | translate}}
		</skl-button>
	</ins-footer>
</skl-dialog-content-ins>